export const CMD_NAME = 'socket optimize'
